import React from "react";
import Experience from "../components/Experience";
import { Layout } from "../components/Layout";

const ExperiencePage = () => {
  return (
    <Layout>
      <Experience />
    </Layout>
  );
};

export default ExperiencePage;
